import { Button } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { DASHBOARD_ACTIVITY, OCCUPANCY } from '../../constants/DashboardConst';
import {
  RBAC_PERMISSION_LEVEL_API_READ_ONLY,
  RBAC_PERMISSION_LEVEL_NO_ACCESS,
} from '../../constants/RoleConsts';
import LinearProgressBar from '../../shared/progress-bar/Progress';
import { checkAuthState } from '../../utils/APIUtils';
import { validateUserSession } from '../../utils/authUtils';
import { getAccessControl } from '../../utils/RBACUtil';
import { selectedHotelSelector } from '../property/propertySlice';
import DailyActivity from './Daily-Activity';
import {
  fetchAllDashboardIrdList,
  getRestaurantId,
  setDashBoardFnbIrdMode,
  setDashboardViewState,
} from './DashboardSlice';
import './Home.scss';

const Home = (props) => {
  const { location, showLoader = () => {}, handleActiveTabRef = null } = props;
  const selectedHotel = useSelector(selectedHotelSelector);
  const [activeTab, setActiveTab] = useState(OCCUPANCY);
  const [userRolePermissions, setUserRolePermissions] = useState(null);
  const [filteredDailyActivities, setFilteredDailyActivities] = useState(DASHBOARD_ACTIVITY);
  const restaurantId = useSelector(getRestaurantId);
  const history = useHistory();
  const dispatch = useDispatch();

  const chatIcon = '/assets/img/chat-icon.png';

  useEffect(() => {
    handleActiveTabRef.current = handleActiveTab;
  }, []);

  useEffect(() => {
    const accessControl = async () => {
      try {
        const perms = await getAccessControl();
        setUserRolePermissions(perms);
      } catch (e) {
        console.error(e);
      }
    };
    accessControl();
  }, []);

  useEffect(() => {
    const adminRole = async () => {
      const currUser = await checkAuthState();
      if (currUser && currUser.attributes && currUser.attributes['custom:role'] === 'SUPER_ADMIN') {
        history.push('/properties');
      }
    };
    adminRole();
  }, []);

  useEffect(() => {
    if (userRolePermissions && DASHBOARD_ACTIVITY && DASHBOARD_ACTIVITY.length) {
      const filterdMenu = DASHBOARD_ACTIVITY.filter((menuItem) => {
        return checkAccessLevel(menuItem.permission);
      }).map((activity, index) => {
        if (location?.state?.activeTab) {
          if (activity.name === location?.state?.activeTab) {
            setActiveTab(activity.name);
            return { ...activity, isActive: true };
          }
        } else {
          if (index === 0) {
            setActiveTab(activity.name);
            return { ...activity, isActive: true };
          }
        }

        return { ...activity, isActive: false };
      });

      if (filterdMenu.length === 0) {
        history.push('/properties');
      } else {
        setFilteredDailyActivities(filterdMenu);
      }
    }
  }, [userRolePermissions, DASHBOARD_ACTIVITY]);

  const handleActiveTab = (currIndex, currName) => {
    const currentDailyActivity = [...filteredDailyActivities];
    const dailyActivitySet = currentDailyActivity.map((activity, index) => {
      if (currIndex === index || currName === activity.name) {
        dispatch(setDashboardViewState({ type: null, status: false, obj: null }));
        setActiveTab(activity.name);
        return { ...activity, isActive: true };
      }
      return { ...activity, isActive: false };
    });
    setFilteredDailyActivities(dailyActivitySet);
  };

  const onClickView = (viewType) => {
    if (selectedHotel) {
      history.push(viewType);
      dispatch(setDashboardViewState({ type: null, status: false, obj: null }));
    }
  };

  useEffect(() => {
    validateUserSession(history);
  }, [activeTab, history]);

  const checkAccessLevel = (accessType) => {
    const accessTypes = Array.isArray(accessType) ? accessType : [accessType];
    for (const permission in userRolePermissions) {
      if (
        accessTypes.some((val) => val === permission) &&
        userRolePermissions[permission] > RBAC_PERMISSION_LEVEL_NO_ACCESS &&
        userRolePermissions[permission] < RBAC_PERMISSION_LEVEL_API_READ_ONLY
      ) {
        return true;
      }
    }
    return false;
  };

  return (
    <div className='home container mw-100'>
      <h4 className='mt-4'>Dashboard</h4>
      {selectedHotel ? (
        <div className='row'>
          <div className='col mt-2'>
            <DailyActivity
              activeTab={activeTab}
              onClickTab={handleActiveTab}
              onClickView={onClickView}
              dailyActivity={filteredDailyActivities}
              selectedHotel={selectedHotel}
              userRolePermissions={userRolePermissions}
              showLoader={showLoader}
            />
          </div>
        </div>
      ) : (
        <div className='pt-4 col col-md-12 pb-4'>
          <LinearProgressBar />
        </div>
      )}
      {/* Temporarily hide this element.
      <div className="d-flex home-chat-icon">
        <Button>
          <img src={chatIcon} alt="icon" className="icon" />
        </Button>
      </div> */}
    </div>
  );
};

export default Home;
